"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[17012,62788],{

/***/ 62788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4298);
/* harmony import */ var _CMSText__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94455);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* provided dependency */ var process = __webpack_require__(34155);






var SharedHead = function(param) {
    var datas = param.datas;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var favicon = (datas === null || datas === void 0 ? void 0 : (ref = datas.data) === null || ref === void 0 ? void 0 : ref.favicon) ? datas.data.favicon : null;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var pageRoute = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var basePath = 'https://' + (process.env.PUBLIC_DOMAIN || ( true ? window.location.host : 0));
        var locale = router.locale === router.defaultLocale ? '' : "/".concat(router.locale);
        var href = "".concat(basePath).concat(locale).concat(router.asPath);
        return href.endsWith('/') ? href.slice(0, -1) : href;
    }, [
        router.asPath,
        router.pathname,
        router.isReady
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(next_head__WEBPACK_IMPORTED_MODULE_2__["default"], {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1, maximum-scale=1"
            }),
            (datas === null || datas === void 0 ? void 0 : (ref1 = datas.data) === null || ref1 === void 0 ? void 0 : ref1.meta_url) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: (0,_CMSText__WEBPACK_IMPORTED_MODULE_4__/* .prismicText */ .yz)(datas === null || datas === void 0 ? void 0 : (ref2 = datas.data) === null || ref2 === void 0 ? void 0 : ref2.meta_url)
            }),
            (datas === null || datas === void 0 ? void 0 : (ref3 = datas.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.meta_image) === null || ref4 === void 0 ? void 0 : ref4.url) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: datas === null || datas === void 0 ? void 0 : (ref5 = datas.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.meta_image) === null || ref6 === void 0 ? void 0 : ref6.url,
                name: "image"
            }),
            process.env.NO_INDEX === undefined && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: pageRoute
            }, "canonical"),
            (favicon === null || favicon === void 0 ? void 0 : favicon.url) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "180x180",
                        href: favicon.url
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "16x16 32x32 48x48",
                        href: favicon['small'].url
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_script__WEBPACK_IMPORTED_MODULE_3__["default"], {
                src: "https://unpkg.com/swiper@6.4.8/swiper-bundle.min.js"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (SharedHead);


/***/ }),

/***/ 87170:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(86010);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75154);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8920);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63457);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(43832);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(22318);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66026);






function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(theme) {
    var _obj;
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        root: (_obj = {
            position: 'relative',
            backgroundColor: theme.extraColors.greyLight,
            backgroundRepeat: 'repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            minHeight: function(LayoutStyle) {
                return (LayoutStyle === null || LayoutStyle === void 0 ? void 0 : LayoutStyle.isZwiterHandCategory) ? 80 : 245;
            }
        }, // minHeight: 245,
        _defineProperty(_obj, theme.breakpoints.down('sm'), {
            zIndex: 1
        }), _defineProperty(_obj, theme.breakpoints.up('sm'), {
            minHeight: 250
        }), _obj),
        heroShopAccordion: {
            minHeight: 118
        },
        heroContainer: _defineProperty({
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: 60
        }, theme.breakpoints.up('sm'), {
            minHeight: 200
        }),
        heroTopTitle: {
            zIndex: 2
        },
        heroTitle: _defineProperty({
            textAlign: 'center',
            zIndex: 2,
            color: theme.palette.common.black
        }, theme.breakpoints.down('md'), {
            fontSize: theme.typography.pxToRem(18)
        }),
        media: {
            zIndex: 1,
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            '&>img': {
                display: 'block',
                width: '100%',
                height: '100%',
                objectFit: 'cover'
            }
        },
        mediaOverlay: {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            opacity: 0.6,
            background: 'linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0.8) 42.42%, rgba(37, 24, 56, 0) 100%)'
        }
    });
});
var HeroShop = function(param) {
    var title = param.title, topTitle = param.topTitle, heroImg = param.heroImg, taxonImg = param.taxonImg, heroSettings = param.heroSettings, isMainTitle = param.isMainTitle, isDisplayAccordionOnMobile = param.isDisplayAccordionOnMobile;
    var ref;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var category = router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.slug;
    var LayoutStyle = {
        isZwiterHandCategory: (category === null || category === void 0 ? void 0 : category.length) && _utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .SECOND_HAND_TAXON_SLUGS.includes */ .$X.includes(category[0])
    };
    var classes = useStyles(LayoutStyle);
    var theme = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
    var heroBgColor = heroSettings === null || heroSettings === void 0 ? void 0 : heroSettings.hero_background_color;
    var heroTextColor = heroSettings === null || heroSettings === void 0 ? void 0 : heroSettings.hero_text_color;
    var heroOverlay = heroSettings === null || heroSettings === void 0 ? void 0 : heroSettings.hero_banner_overlay;
    var useTaxonImage = heroSettings === null || heroSettings === void 0 ? void 0 : heroSettings.use_taxon_img;
    var isMobile = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(theme.breakpoints.down('xs'));
    var isTablet = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(theme.breakpoints.down('md'));
    var isDesktop = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(theme.breakpoints.up('lg'));
    var isDesktopXL = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(theme.breakpoints.up('xl'));
    var imagePath = (taxonImg === null || taxonImg === void 0 ? void 0 : taxonImg.cachedPath) || (taxonImg === null || taxonImg === void 0 ? void 0 : taxonImg.path) ? "".concat("https://ik.imagekit.io/lizee/rp-millet-production/", "/").concat(taxonImg === null || taxonImg === void 0 ? void 0 : taxonImg.path) : undefined;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)("hero--shop ".concat(classes.root), isMobile && _utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .isSubscription */ .Nn && isDisplayAccordionOnMobile && classes.heroShopAccordion),
        style: {
            backgroundColor: heroBgColor
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(classes.heroContainer, 'hero__title__container'),
            children: [
                topTitle && topTitle.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    variant: "h4",
                    component: "p",
                    className: "hero__toptitle ".concat(classes.heroTopTitle),
                    style: {
                        color: heroTextColor
                    },
                    children: topTitle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    variant: "h2",
                    component: isMainTitle ? 'h1' : 'div',
                    className: "hero__title ".concat(classes.heroTitle, " ").concat(LayoutStyle.isZwiterHandCategory && 'hero__title--second-hand'),
                    style: {
                        color: heroTextColor
                    },
                    children: title
                }),
                !useTaxonImage && (heroImg === null || heroImg === void 0 ? void 0 : heroImg.url) !== undefined ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: classes.media,
                    children: [
                        heroOverlay && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: classes.mediaOverlay,
                            id: "mediaOverlay"
                        }),
                        isTablet && (isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: (heroImg.small || heroImg.sm).url,
                            alt: ''
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: (heroImg.medium || heroImg.md).url,
                            alt: ''
                        })),
                        isDesktop && (isDesktopXL && !!heroImg.xl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: heroImg.xl.url,
                            alt: ''
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: heroImg.url,
                            alt: ''
                        }))
                    ]
                }) : imagePath && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: classes.media,
                    children: [
                        heroOverlay && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: classes.mediaOverlay,
                            id: "mediaOverlay"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: imagePath,
                            alt: ''
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroShop);


/***/ }),

/***/ 8122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Header__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49841);
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79956);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(86010);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9008);
/* harmony import */ var _utils_scrollState__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75216);
/* harmony import */ var _Global_SharedHead__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62788);
/* harmony import */ var _Global_CMSText__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94455);









var Layout = function(param) {
    var children = param.children, doc = param.doc, account = param.account, faq = param.faq, hideTop = param.hideTop, mainLogo = param.mainLogo, headerTitle = param.headerTitle, t = param.t, inStoreText = param.inStoreText, banner = param.banner, metaTitle = param.metaTitle, metaDescription = param.metaDescription, metaKeywords = param.metaKeywords, metaDescriptionProduct = param.metaDescriptionProduct, metaKeywordsProduct = param.metaKeywordsProduct, metaImage = param.metaImage, pageType = param.pageType, takeback = param.takeback, basket = param.basket, pageName = param.pageName;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var scrollState = (0,_utils_scrollState__WEBPACK_IMPORTED_MODULE_5__/* .useScrollState */ .M)();
    var isBanner = (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_7__/* .isPrismicText */ .LT)(banner === null || banner === void 0 ? void 0 : (ref = banner.data) === null || ref === void 0 ? void 0 : ref.text);
    var isDisplayedBannerOnAllPages = banner === null || banner === void 0 ? void 0 : (ref1 = banner.data) === null || ref1 === void 0 ? void 0 : ref1.is_displayed_banner_on_all_pages;
    var metaTitleString = metaTitle && (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_7__/* .isPrismicText */ .LT)(doc === null || doc === void 0 ? void 0 : (ref2 = doc.data) === null || ref2 === void 0 ? void 0 : ref2.baseline) ? "".concat((0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_7__/* .prismicText */ .yz)(doc === null || doc === void 0 ? void 0 : (ref3 = doc.data) === null || ref3 === void 0 ? void 0 : ref3.baseline), " - ").concat(metaTitle) : metaTitle;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)('page', pageType && "page--".concat(pageType)),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_SharedHead__WEBPACK_IMPORTED_MODULE_6__["default"], {
                datas: doc
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(next_head__WEBPACK_IMPORTED_MODULE_4__["default"], {
                children: [
                    metaTitleString && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                                children: metaTitleString
                            }, "pageTitle"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:title",
                                name: "title",
                                content: metaTitleString
                            })
                        ]
                    }),
                    metaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        name: "description",
                        content: metaDescription
                    }),
                    (metaKeywords === null || metaKeywords === void 0 ? void 0 : metaKeywords.length) && ((ref4 = metaKeywords[0]) === null || ref4 === void 0 ? void 0 : ref4.text) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:keywords",
                        name: "keywords",
                        content: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_7__/* .prismicText */ .yz)(metaKeywords)
                    }),
                    metaKeywordsProduct && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:keywords",
                        name: "keywords",
                        content: metaKeywordsProduct
                    }),
                    metaDescriptionProduct && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        name: "description",
                        content: metaDescriptionProduct
                    }),
                    metaImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:image",
                                content: metaImage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                name: "twitter:image",
                                content: metaImage
                            })
                        ]
                    })
                ]
            }),
            !(doc === null || doc === void 0 ? void 0 : (ref5 = doc.data) === null || ref5 === void 0 ? void 0 : ref5.hide_header) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Header__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                logo: mainLogo,
                t: t,
                title: headerTitle,
                inStoreText: inStoreText,
                doc: doc,
                account: account,
                faq: faq,
                showOnScrollUp: scrollState.showOnScrollUp,
                showOnTop: scrollState.showOnTop,
                textColor: doc === null || doc === void 0 ? void 0 : (ref6 = doc.data) === null || ref6 === void 0 ? void 0 : ref6.header_text_color,
                background: doc === null || doc === void 0 ? void 0 : (ref7 = doc.data) === null || ref7 === void 0 ? void 0 : ref7.header_background,
                hoverColor: doc === null || doc === void 0 ? void 0 : (ref8 = doc.data) === null || ref8 === void 0 ? void 0 : ref8.header_text_hover_color,
                basket: basket,
                takeback: takeback,
                submenuBackgroundColor: doc === null || doc === void 0 ? void 0 : (ref9 = doc.data) === null || ref9 === void 0 ? void 0 : ref9.header_submenu_background_color,
                submenuTextColor: doc === null || doc === void 0 ? void 0 : (ref10 = doc.data) === null || ref10 === void 0 ? void 0 : ref10.header_submenu_text_color,
                isBanner: isBanner,
                isDisplayedBannerOnAllPages: isDisplayedBannerOnAllPages,
                banner: banner,
                pageName: pageName
            }),
            children,
            !(doc === null || doc === void 0 ? void 0 : (ref11 = doc.data) === null || ref11 === void 0 ? void 0 : ref11.hide_footer) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Footer__WEBPACK_IMPORTED_MODULE_2__["default"], {
                doc: doc,
                t: t,
                hideTop: hideTop
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Layout);


/***/ }),

/***/ 45889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75154);

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
// const menuWidth = 220
var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(theme) {
    var _obj, _obj1, _obj2, _obj3, _obj4;
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        root: {
            minHeight: '100vh',
            position: 'relative',
            zIndex: 2
        },
        shopContent: _defineProperty({
            position: 'relative',
            zIndex: 1,
            marginTop: -16,
            borderRadius: 0,
            background: theme.palette.common.white
        }, theme.breakpoints.up('sm'), {
            marginTop: -30
        }),
        shopContentSingle: _defineProperty({}, theme.breakpoints.down('sm'), {
            marginTop: 0
        }),
        shopContainer: {
            minHeight: '50vh',
            paddingTop: theme.spacing(4),
            paddingBottom: theme.spacing(4)
        },
        shopPlanner: (_obj = {
            position: 'relative',
            zIndex: 4,
            padding: theme.spacing(1.8),
            // marginTop: -200,
            marginTop: function(LayoutStyle) {
                return (LayoutStyle === null || LayoutStyle === void 0 ? void 0 : LayoutStyle.isZwiterHandCategory) ? 0 : -200;
            },
            minHeight: 200,
            boxShadow: theme.shadows[1],
            borderRadius: theme.shape.borderRadius,
            background: theme.palette.common.white
        }, _defineProperty(_obj, theme.breakpoints.up('sm'), {
            padding: theme.spacing(1.8, 3),
            marginTop: function(LayoutStyle) {
                return (LayoutStyle === null || LayoutStyle === void 0 ? void 0 : LayoutStyle.isZwiterHandCategory) ? 0 : -theme.spacing(9);
            },
            minHeight: 80,
            marginLeft: 'auto',
            marginRight: 'auto'
        }), _defineProperty(_obj, '&:empty', {
            '&+ .MuiContainer-root': _defineProperty({
                zIndex: 5,
                marginTop: -theme.spacing(23),
                position: 'relative'
            }, theme.breakpoints.up('sm'), {
                marginTop: -theme.spacing(12.5)
            })
        }), _obj),
        shopPlannerDad: (_obj1 = {}, _defineProperty(_obj1, theme.breakpoints.up('lg'), {
            maxWidth: theme.breakpoints.width('lg') + theme.spacing(4)
        }), _defineProperty(_obj1, theme.breakpoints.up('xl'), {
            maxWidth: theme.breakpoints.width('lg') + theme.spacing(8)
        }), _obj1),
        shopPlannerColumn: (_obj2 = {}, _defineProperty(_obj2, theme.breakpoints.up('sm'), {
            minHeight: 50
        }), _defineProperty(_obj2, '&:empty', {
            '&+ .MuiContainer-root': _defineProperty({}, theme.breakpoints.up('sm'), {
                marginTop: -theme.spacing(5)
            })
        }), _obj2),
        shopPlannerMobileAccordion: {
            marginTop: -27,
            minHeight: 60
        },
        shopArea: _defineProperty({
            paddingTop: theme.spacing(1),
            paddingBottom: theme.spacing(2)
        }, theme.breakpoints.up('sm'), {
            paddingTop: theme.spacing(4),
            paddingBottom: theme.spacing(4)
        }),
        shopAreaSingle: _defineProperty({}, theme.breakpoints.down('sm'), {
            padding: 0
        }),
        shopAreaColumn: (_obj3 = {
            marginTop: -theme.spacing(22),
            paddingTop: 0,
            paddingLeft: theme.spacing(1),
            paddingRight: theme.spacing(1),
            position: 'relative',
            zIndex: 5
        }, _defineProperty(_obj3, theme.breakpoints.up('sm'), {
            marginTop: -theme.spacing(6)
        }), _defineProperty(_obj3, theme.breakpoints.up('lg'), {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }), _obj3),
        shopIntro: _defineProperty({
            overflow: 'hidden',
            maxWidth: theme.breakpoints.width('lg'),
            margin: theme.spacing(3, 'auto'),
            '&>div>div>.MuiTypography-root': {
                marginBottom: theme.spacing(1.5),
                '&>span': {
                    marginLeft: theme.spacing(1.5)
                }
            },
            '&:empty': {
                margin: 0
            }
        }, theme.breakpoints.down('sm'), {
            '&>.MuiGrid-root>.MuiGrid-item+.MuiGrid-item': {
                marginTop: -theme.spacing(4.5)
            }
        }),
        shopIntroMobileAccordion: {
            overflow: 'hidden',
            marginBottom: theme.spacing(2),
            '& .MuiAccordion-root': {
                boxShadow: 'none',
                '& .MuiAccordionSummary-root': {
                    margin: theme.spacing(1, 0, 0),
                    minHeight: 'auto',
                    borderRadius: theme.shape.borderRadius,
                    backgroundColor: theme.extraColors.greyLight
                },
                '& .MuiAccordionSummary-content': {
                    margin: theme.spacing(1, 0)
                }
            },
            '& .MuiAccordionDetails-root': {
                padding: theme.spacing(2, 1)
            }
        },
        shopMenu: (_obj4 = {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        }, _defineProperty(_obj4, theme.breakpoints.up('md'), {
            flexDirection: 'row'
        }), _defineProperty(_obj4, theme.breakpoints.down('xs'), {
            display: 'block'
        }), _obj4),
        shopMenuList: {},
        shopMenuCta: _defineProperty({}, theme.breakpoints.down('sm'), {
            display: 'flex',
            flexDirection: 'row-reverse',
            paddingTop: theme.spacing(2)
        }),
        shopMenuRightControls: {
            display: 'flex',
            gap: theme.spacing(2)
        },
        shopMenuRightControlsIconContainer: {
            display: 'none'
        },
        shopMenuSortInput: {
            width: 172
        },
        shopCard: {
            position: 'relative',
            overflow: 'hidden',
            height: '100%',
            boxShadow: theme.shadows[1],
            borderRadius: theme.shape.borderRadius,
            backgroundColor: theme.palette.common.white,
            '@media (hover: hover)': {
                '& .glider-next,.glider-prev,.product__variants': {
                    display: 'none'
                },
                '&:hover': {
                    '& .glider-next,.glider-prev,.product__variants': {
                        display: 'flex'
                    }
                }
            }
        },
        shopApiContent: {
            '& iframe': {
                width: '100%'
            },
            '& table': {
                width: '100%',
                tableLayout: 'fixed',
                borderCollapse: 'collapse',
                borderColor: theme.extraColors.greyMedium,
                '& td': {
                    padding: theme.spacing(0.5, 1),
                    borderColor: theme.extraColors.greyMedium
                },
                '& tr:nth-child(even) td': {
                    backgroundColor: theme.extraColors.greyLight
                }
            }
        },
        shopFilters: {},
        stickyBar: {
            zIndex: 3,
            position: 'sticky',
            transition: theme.transitions.create('top'),
            top: theme.sizes.headerHeight,
            paddingTop: theme.spacing(1),
            paddingBottom: theme.spacing(1)
        },
        stickyBarScrollUp: {
            transition: theme.transitions.create('top'),
            top: 0
        },
        stickyBarSticked: {
            '&:before': {
                zIndex: -1,
                content: '""',
                width: '100vw',
                transform: 'translateX(-50%) translateY(0)',
                left: '50%',
                height: '100%',
                position: 'absolute',
                top: 0,
                right: 0,
                background: theme.palette.common.white,
                boxShadow: theme.shadows[1]
            }
        },
        stickyBarTop: {
            boxShadow: 'none',
            '&:before': {
                display: 'none'
            }
        },
        availability: {
            display: 'inline-block',
            top: theme.spacing(2),
            padding: theme.spacing(1, 1.5),
            fontSize: 11,
            borderRadius: 36,
            textAlign: 'center'
        },
        unavailable: {
            color: theme.palette.common.white,
            background: theme.palette.error.light
        },
        enought: {
            color: theme.palette.ternary.main,
            background: theme.palette.ternary.light
        },
        available: {
            color: theme.palette.common.white,
            background: theme.palette.success.main
        },
        noBoxShadow: {
            boxShadow: 'none'
        },
        loader: {
            zIndex: theme.zIndex.tooltip,
            position: 'fixed',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(255,255,255, .5)'
        },
        no_product: {
            textAlign: 'center',
            marginTop: theme.spacing(4)
        },
        hideDatePicker: {
            display: 'none'
        },
        reservationAlert: {
            alignItems: 'center'
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (useStyles);


/***/ })

}]);